import { useSelector } from 'react-redux';

//Component
import Main from 'components/common/Layout/Main';
import AppLanding from 'components/templates/landing';

// Libs
import Translation from 'libs/Translation';

const App = () => {
	const {webConfig} = useSelector(state => state.core);

    const title = Translation.t('title.download-vclinic-app');
	const description = Translation.t('text.download-vclinic-app');

	const breadCrumb = {
		itemListElements: [
			{
				position: 1,
				name: Translation.t('title.default'),
				item: 'https://vclinic.io',
			},
			{
				position: 2,
				name: Translation.t('title.download-vclinic-app'),
				item: `https://vclinic.io/landing`,
			},
		],
	};

	const seo = {
		title: `${title} | ${Translation.t('title.default')}`,
        description: description,
		h1Title: title,
		additionalMetaTags: [],
	};

    return (
        <Main breadCrumb={breadCrumb} seo={seo}>
            <AppLanding webConfig={webConfig}/>
        </Main>
    )
}
export default App;